export default "<form>\n  <input id=\"myForm\" type=\"file\" name=\"file\" (change)=\"postMethod($event.target.files)\">\n</form>\n"